// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useAppState } from "../../../../states/app-state";
import styles from './congratulations.module.scss';
import DisabledClickLoading from "../../../../components/DisabledClickLoading";
import { useThemeMode } from "../../../../states/contexts/theme";

const Congratulations: React.FC = observer(() => {
    const appState = useAppState();
    const [loading, setLoading] = useState(false);
    const { accountVerification, createAccount } = appState;
    const handleClose = async () => {
        setLoading(true);
        await appState?.login?.loadState(createAccount?.uid);
        // window.location.reload();
        setLoading(false);
        accountVerification?.setOpenTwoStep(false);
    }
    const { theme } = useThemeMode();
    return (
        <div className={styles.congratulations} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <header>
                <h5>Congratulations!</h5>
                <Button onClick={handleClose}><img src="/cancel.png" alt="X" width={28} height={28} /></Button>
            </header>
            <p>Your profile is now complete, and you can access all the app's features.</p>
            <Button type='button' className={styles.button} disableRipple={true} onClick={handleClose}>
                <span>OK</span>
            </Button>
            {loading && <DisabledClickLoading />}
        </div>
    )
})
export default Congratulations;